import React from 'react';
import RecordIcon from '../Icon/Record';
import './LoadingIndicator.css';

export default () => {
  return (
    <span className="LoadingIndicator">
      <span>
        <RecordIcon height="50px" width="50px" fill="#FFF" />
      </span>
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/component/atoms/LoadingIndicator/index.js